

























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { unCreateList, hideQuality, createQualityTable, departments } from '@/api/quality';
import moment from 'moment';
import store from '@/store';
import { hasPermission } from '@/utils/utils';
import selectMember from '@/components/project/selectMember.vue';
import { supportList } from '@/utils/meeting';
import { mapGetters } from 'vuex';

const meetingCategoryMap = {
  1: 'Early',
  2: 'Early Growth',
  3: 'Growth',
  5: 'Late Growth',
  6: 'Seed'
};

const meetingGoalMap = {
  2: 'Onepager',
  3: 'DD Memo(Pre-TS)',
  4: 'DD Memo(Pre-SPA)',
  5: 'DD Memo(Pre交割)',
  7: 'PreLoan'
};

const columns = [
  {
    title: '项目名称',
    dataIndex: 'companyName',
    key: 'companyName'
  },
  {
    title: '轮次',
    dataIndex: 'roundName',
    key: 'roundName',
    width: '80px',
    customRender: data => {
      return data + '轮';
    }
  },
  {
    title: '上会分类',
    dataIndex: 'meetingCategory',
    align: 'center',
    width: '100px',
    key: 'meetingCategory',
    customRender: val => {
      return meetingCategoryMap[val];
    }
  },
  {
    title: '上会目的',
    dataIndex: 'meetingGoal',
    align: 'center',
    key: 'meetingGoal',
    width: '200px',
    customRender: val => {
      return meetingGoalMap[val];
    }
  },
  {
    title: '上会时间',
    dataIndex: 'time',
    align: 'center',
    key: 'time',
    width: '100px'
  },
  {
    title: 'DL',
    dataIndex: 'dlName',
    align: 'center',
    width: '80px',
    key: 'dlName'
  },
  {
    title: 'DM',
    dataIndex: 'dmStr',
    key: 'dmStr',
    width: '10%',
    align: 'center'
  },
  {
    title: '操作',
    align: 'center',
    width: '250px',
    scopedSlots: {
      customRender: 'action'
    }
  }
];

// const supportList = [
//   {
//     id: 1,
//     name: 'FDD'
//   },
//   {
//     id: 2,
//     name: 'LDD'
//   },
//   {
//     id: 4,
//     name: 'HDD'
//   },
//   {
//     id: 8,
//     name: 'ITDD'
//   },
//   {
//     id: 16,
//     name: '财务（人民币）'
//   },
//   {
//     id: 32,
//     name: '财务（美元）'
//   },
//   {
//     id: 64,
//     name: 'PDD'
//   },
//   {
//     id: 128,
//     name: '揽星'
//   },
//   {
//     id: 0,
//     name: '暂无'
//   }
// ];

@Component({
  components: { selectMember },
  computed: { ...mapGetters(['userInfo']) }
})
class createQuality extends Vue {
  userInfo: any;
  columns: any[] = columns;
  data: any[] = [];
  keyword: string = '';
  total: number = 0;
  pageSize: number = 10;
  showModal: string = '';
  companyObj: object = {};
  supportList: any[] = supportList;
  departmentList: any[] = [];
  permission: boolean = false;
  meetingCategoryMap: object = meetingCategoryMap;
  meetingGoalMap: object = meetingGoalMap;
  page: number = 1;
  dl: any[] = [];
  dm: any[] = [];

  async created() {
    const { permissions: queue } = this.userInfo || {};
    this.permission = hasPermission(queue, '/systemSetting/manage/projectQuality/createComment');
    this.getDepartments();
    await this.getList();
    if (this.$route.query.id) {
      this.showCreateModal(this.data[0]);
    }
  }

  async getList() {
    try {
      let res = await unCreateList({
        page: this.page,
        pageSize: this.pageSize,
        companyName: this.keyword,
        id: this.$route.query.id
      });
      if (res.code === 200) {
        this.data =
          res.data.list.map(_ => {
            return {
              ..._,
              time: _.meetingDate ? moment(_.meetingDate).format('YYYY-MM') : '',
              dmStr: _.dmStr ? _.dmStr.join('、') : ''
            };
          }) || [];
        this.total = res.data.total;
      }
    } catch (err) {
      console.log(err);
    } finally {
      return Promise.resolve();
    }
  }

  handleSearch() {
    this.page = 1;
    this.getList();
  }

  onChange(page, pageSize) {
    this.page = page;
    this.getList();
  }

  hideNoticeModal(data) {
    this.showModal = 'hideNotice';
    this.companyObj = data;
  }

  closeNoticeModal() {
    this.showModal = '';
    this.companyObj = {};
  }

  async hideQuality() {
    try {
      let res = await hideQuality({ id: this.companyObj['id'] });
      if (res.code === 200) {
        this.$message.success('操作成功');
        this.closeNoticeModal();
        this.page = 1;
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  showCreateModal(data) {
    this.showModal = 'createTable';
    this.companyObj = data;
    this.dl = [{ id: Number(data.dl), nickname: data.dlName }];
    let dmIds = [];
    let dmArr = [];
    if (data.dmIds) {
      dmIds = data.dmIds.split(',');
      dmArr = data.dmStr.split('、');
    }
    if (dmIds.length > 0) {
      dmIds.forEach((_, index) => {
        this.dm.push({ id: Number(_), nickname: dmArr[index] });
      });
    }
    let departments = data.departments;
    this.supportList.forEach(_ => {
      if (departments.indexOf(_.id) !== -1) {
        _.checked = true;
      } else {
        _.checked = false;
      }
    });
    if (departments.length === 0) {
      this.supportList.find(_ => _.id === 0).checked = true;
    } else if (departments.length === 1 && (departments.indexOf(256) > -1 || departments.indexOf(512) > -1)) {
      this.supportList.find(_ => _.id === 0).checked = true;
    } else if (departments.length === 2 && departments.indexOf(256) > -1 && departments.indexOf(512) > -1) {
      this.supportList.find(_ => _.id === 0).checked = true;
    }
  }

  closeCreateModal() {
    this.showModal = '';
    this.companyObj = {};
    this.dl = [];
    this.dm = [];
    this.supportList.forEach(_ => {
      _.checked = false;
    });
  }

  checkChange(index, data) {
    this.$set(this.supportList, index, { ...data, checked: !data.checked });
  }

  async createQuality() {
    try {
      if (this.valideQuality()) {
        let departments: any[] = [];
        this.supportList.forEach(_ => {
          if (_.checked === true) {
            departments.push(_.id);
          }
        });
        let dl = this.dl[0].id;
        let dm: any[] = [];
        if (this.dm.length > 0) {
          dm = this.dm.map(_ => {
            return _.id;
          });
        }
        let res = await createQualityTable({ id: this.companyObj['id'], departments: departments, dl: dl, dm: dm });
        if (res.code === 200) {
          this.$message.success('创建成功');
          this.closeCreateModal();
          this.page = 1;
          this.getList();
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  valideQuality() {
    if (this.supportList.some(_ => _.checked === true)) {
      if (this.dl.length > 0) {
        return true;
      } else {
        this.$message.error('DL不能为空');
      }
    } else {
      this.$message.error('请选择支持部门');
      return false;
    }
  }

  async getDepartments() {
    try {
      let res = await departments();
      if (res.code === 200) {
        this.departmentList = res.data || [];
      }
    } catch (err) {
      console.log(err);
    }
  }

  choseDLId(val) {
    console.log(val);
    console.log(typeof val[0].id);
    this.dl = val;
  }

  delDLId(val) {
    this.dl = [];
  }

  choseDMId(val) {
    this.dm = val;
  }

  delDMId(val) {
    this.dm = this.dm.filter(_ => _.id !== val.id);
  }
}
export default createQuality;
